/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';
import apis from '../../../app/apis';
import cts from '../../../app/cts';
import { BackButton, Drawer } from '../../../components';
import oneOf from '../DepoEvents_Components/helpers';

import {
  Loading, Header, Details, StaticMap, Contact
} from '../DepoEvents_Components';


const endpoints = ({ localityId, matId }) => ({
  'event-list': apis.getEventDetailsApi(localityId, matId),
  'depo-list': apis.getDepoDetailsApi(localityId, matId),
});


/**
 * Get details hook
 *
 * @param {number} matId
 */
const useDepoEventDetails = (localityId, matId, kind) => {
  const [details, setDetails] = useState({});
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getDepoEvents = async () => {
      try {
        setLoading(true);
        const { data, status } = await cts('get', endpoints({ localityId, matId })[kind]);
        if (!data && status !== 200) {
          throw new Error('Error getting event details');
        }
        setDetails(oneOf(['eventDetails', 'depotDetails'], data.content.response));
      } catch (e) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    getDepoEvents();
  }, [matId, localityId, kind]);
  return {
    details,
    error,
    loading
  };
};


const Container = styled.div`
  height: auto;
  overflow: auto;
`;


const DepoEventDetails = ({ localityId, location }) => {
  const depotEventId = location.state.id;
  const { kind } = location.state; // Depo details or Event details
  const { loading, error, details } = useDepoEventDetails(localityId, depotEventId, kind);

  const depoEventName = oneOf(['event_nm', 'depot_nm'], details);
  const depoEventDetails = oneOf(['event_details', 'depot_details'], details);

  // TODO: Add season section
  return (
    <Container>
      <BackButton />
      {
        loading && <Loading />
      }
      {
        !error
        && Object.keys(details).length
          ? (
            <div style={{ padding: '10px'}}>
              <Header>
                {depoEventName}
              </Header>
              {
                depoEventDetails
                && depoEventDetails.length
                && depoEventDetails !== 'null'
                  ? (
                    <Details tabIndex="-1">
                      <div dangerouslySetInnerHTML={{ __html: depoEventDetails }} />
                    </Details>
                  ) : null
              }
              {
                details.geo_lng
                && details.geo_lat
                  ? (
                    <StaticMap
                      lat={details.geo_lat}
                      lng={details.geo_lng}
                      tabIndex="0"
                      onClick={() => {
                        window.open(`https://www.google.com/maps/dir//${details.geo_lat},${details.geo_lng}/@${details.geo_lat},${details.geo_lng},17z/data=!4m2!4m1!3e0`);
                      }}
                    />
                  ) : null
              }
              {
                (
                  details.phone_nbr
                  && details.phone_nbr !== 'null'
                ) || (
                  details.email_addr
                  && details.email_addr !== 'null'
                ) ? (
                  <Contact
                    phone={details.phone_nbr}
                    email={details.email_addr}
                  />
                  ) : null
              }
              {
                details.links.length
                  ? (
                    details.links.map((link) => (
                      <Drawer
                        key={`${oneOf(['drop_event_loc_id', 'drop_depot_id'], details)}-${link.drawer_title}`}
                        link={link}
                        tabIndex="0"
                      />
                    ))
                  ) : null
              }
            </div>
          ) : null
      }
    </Container>
  );
};

export default withRouter(connect((state) => (
  { localityId: state.app.localityId }
))(DepoEventDetails));
